import { dataMotionGraphics } from 'dls-icons-data'
import { createIcon } from '../common'

const IconMotionGraphics = /*#__PURE__*/createIcon(dataMotionGraphics)
export default IconMotionGraphics
